import React, { FC, ReactNode } from 'react';
import { StyledLink, StyledLinkButton } from './CallToActionLink.styles';
import { getLinkId } from '../../../util/getLinkId';

export type Size = 'sm' | 'md' | 'lg';

export interface CommonProps {
  size: Size;
  isSelected?: boolean;
  dataTestId?: string;
  selected?: boolean;
  selectable?: boolean;
  children?: string | ReactNode;
  rel?: string;
  to?: string;
}

export type CallToActionLinkProps = Omit<CommonProps, 'children'> &
  React.AnchorHTMLAttributes<HTMLAnchorElement>;

export type CallToActionLinkButtonProps = Omit<CommonProps, 'children'> &
  Omit<React.ButtonHTMLAttributes<HTMLButtonElement>, 'type' | 'children'> & {
    type: 'button' | 'submit' | 'reset';
    disabled: boolean;
    children?: ReactNode;
  };

const fallbackTitle = 'link';

export const CallToActionLink: FC<CallToActionLinkProps> = ({
  size,
  isSelected,
  dataTestId,
  selected,
  selectable,
  children,
  rel,
  to,
  href,
  ...rest
}) => {
  if (!to && !href) {
    return null;
  }

  const title = typeof children === 'string' ? children : fallbackTitle;

  return (
    <StyledLink
      to={(to ?? href) as string}
      size={size}
      selected={isSelected}
      id={getLinkId(title, to)}
      {...rest}
    >
      {children}
    </StyledLink>
  );
};

export const CallToActionLinkButton: FC<CallToActionLinkButtonProps> = ({
  size,
  isSelected,
  dataTestId,
  selected,
  selectable,
  children,
  rel,
  type,
  disabled,
  ...rest
}) => {
  return (
    <StyledLinkButton
      type={type}
      size={size}
      selected={isSelected}
      disabled={disabled}
      {...rest}
    >
      {children}
    </StyledLinkButton>
  );
};

export default CallToActionLink;
